<!-- <div class="d-flex flex-row justify-content-between px-3">
  <h2 mat-dialog-title class="headingBL">Message</h2> -->
<!-- <div mat-dialog-actions class="btnGlobal--secondary">close</div> -->
<!-- <img
    mat-dialog-actions
    (click)="closeDialog()"
    src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/icons/ic_close.png"
    alt="close"
    style="width: 2rem; height: 2rem"
    class="point"
  />
</div> -->
<div mat-dialog-content class="d-flex flex-row gap-2">
  <div class="vtext" style="text-align: center" *ngIf="data.error != null">
    {{ data.error }}
  </div>
  <div class="vtext" style="text-align: center" *ngIf="data.error == null">
    Site Under Construction<br />
    Please download Android Application from
    <a href="https://play.google.com/store/apps/details?id=com.virsa.app&pli=1"
      >here</a
    >
  </div>
</div>
